"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _orderFormTypes = require("../../constants/sendOrder/orderFormTypes");
var _orderHelper = require("../../helpers/orderHelper");
var _modalDecorator = _interopRequireDefault(require("../../hocs/modalDecorator"));
var _modalActions = require("../../redux/actions/modalActions");
var _orderEntryActions = require("../../redux/actions/orderEntryActions");
var _selectors = require("../../redux/margin/selectors");
var _futuresLeverageSelectors = require("../../redux/futures/selectors/futuresLeverageSelectors");
var _buySellSelectors = require("../../redux/selectors/buySellSelectors");
var _instrumentPositionSelectors = require("../../redux/selectors/instrumentPositionSelectors");
var _orderEntrySelector = require("../../redux/selectors/orderEntrySelector");
var _ConfirmOrderModalComponent = _interopRequireDefault(require("./ConfirmOrderModalComponent"));
var _marginActions = require("../../redux/margin/actions/marginActions");
var _actions = require("../../redux/margin/actions");
var _futuresSelectors = require("../../redux/futures/selectors/futuresSelectors");
var _FuturesOrderEntryFormContainer = require("../OrderEntryComponents/futures/FuturesOrderEntryForm/FuturesOrderEntryFormContainer");
var _productsSelectors = require("../../redux/selectors/productsSelectors");
var _selectors2 = require("../../redux/futures/selectors");
var _decimalPlacesHelper = require("../../helpers/decimalPlaces/decimalPlacesHelper");
var _futuresOrdersSelectors = require("../../redux/futures/selectors/futuresOrdersSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state, props) {
  var _formObj$values$fee, _formObj$values$fee2;
  var ORDER_ENTRY_FORM_ID = props.formName || 'orderEntry';
  var form = state.form,
    product = state.apexCore.product;
  var formObj = form[ORDER_ENTRY_FORM_ID] || {
    values: {
      fee: {}
    }
  };
  var isFuturesActive = (0, _futuresSelectors.isFuturesActiveSelector)(state);
  var productId = ((_formObj$values$fee = formObj.values.fee) === null || _formObj$values$fee === void 0 ? void 0 : _formObj$values$fee.ProductId) || ((_formObj$values$fee2 = formObj.values.fee) === null || _formObj$values$fee2 === void 0 ? void 0 : _formObj$values$fee2.FeeProductId);
  var feeSymbol = productId ? product.products.find(function (item) {
    return item.ProductId === productId;
  }).Product : '';
  var marketPriceSelector = isFuturesActive ? _buySellSelectors.marketPriceOfSelectedFuturesInstrumentSelector : _buySellSelectors.marketPriceOfSelectedInstrumentSelector;
  var marketPrice = marketPriceSelector(state, {
    side: formObj.values.side,
    formatToLocale: false
  });
  var bestAskPrice = (0, _selectors2.futuresInstrumentBestAskPriceSelector)(state);
  var price = isFuturesActive ? (0, _orderHelper.getFuturesOrderEntryPrice)(formObj === null || formObj === void 0 ? void 0 : formObj.values, bestAskPrice) : (0, _orderHelper.getOrderPrice)(formObj, marketPrice);
  var selectedInstrument = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state);
  var orderTotal = (0, _orderEntrySelector.orderTotalSelector)(state, props);
  var leverage = isFuturesActive ? (0, _futuresLeverageSelectors.currentFuturesLeverageSelector)(state) : (0, _selectors.currentLeverageSelector)(state, formObj.values.side);
  var productDecimalPlaces = (0, _productsSelectors.decimalsByProductId)(state);
  var Product1Id = selectedInstrument.Product1,
    Product2Id = selectedInstrument.Product2;
  var product1DecimalPlaces = productDecimalPlaces[Product1Id] || 8;
  var product2DecimalPlaces = productDecimalPlaces[Product2Id] || 8;
  var futuresBuyOrderCost = (0, _futuresOrdersSelectors.futuresBuyOrderCostSelector)(state);
  var futuresSellOrderCost = (0, _futuresOrdersSelectors.futuresSellOrderCostSelector)(state);
  var futuresOrderCost = formObj.values.side == 0 ? futuresBuyOrderCost : futuresSellOrderCost;
  var quantityDP = selectedInstrument ? (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument === null || selectedInstrument === void 0 ? void 0 : selectedInstrument.QuantityIncrement) : 2;
  var valueDP = selectedInstrument ? (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument === null || selectedInstrument === void 0 ? void 0 : selectedInstrument.PriceIncrement) : 2;
  var isOrderByQty = formObj.values.orderByProduct === (selectedInstrument === null || selectedInstrument === void 0 ? void 0 : selectedInstrument.Product1Symbol);
  var futuresAmount = isOrderByQty ? formObj.values.quantity : formObj.values.value;
  var futuresValue = isOrderByQty ? formObj.values.value : formObj.values.quantity;
  var futuresValueDecimalPlaces = isOrderByQty ? valueDP : quantityDP;
  return {
    formObj: formObj,
    feeSymbol: feeSymbol,
    price: price,
    selectedInstrument: selectedInstrument,
    isMarginActive: (0, _selectors.isMarginActiveSelector)(state),
    selectedMarginInstrument: (0, _selectors.selectMarginInstrumentConfig)(state),
    orderTotal: orderTotal,
    level1: state.apexCore.level1[selectedInstrument.InstrumentId],
    leverage: leverage,
    isFuturesActive: isFuturesActive,
    futuresFormValues: (0, _orderEntrySelector.selectOrderFormValues)(state, {
      formName: _FuturesOrderEntryFormContainer.FUTURES_ORDER_FORM_NAME
    }),
    product1DecimalPlaces: product1DecimalPlaces,
    product2DecimalPlaces: product2DecimalPlaces,
    futuresAmount: futuresAmount,
    quantityDP: quantityDP,
    valueDP: valueDP,
    futuresValue: futuresValue,
    futuresValueDecimalPlaces: futuresValueDecimalPlaces,
    futuresOrderCost: futuresOrderCost
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var ORDER_ENTRY_FORM_ID = ownProps.formName || 'orderEntry';
  var orderFormType = ORDER_ENTRY_FORM_ID === 'advancedOrderEntry' ? _orderFormTypes.orderFormTypes.advanced : _orderFormTypes.orderFormTypes["default"];
  return {
    confirmReport: function confirmReport(formValues) {
      dispatch((0, _orderEntryActions.placeOrder)(orderFormType, formValues)).then(function () {
        dispatch((0, _reduxForm.reset)(ORDER_ENTRY_FORM_ID));
        dispatch((0, _reduxForm.change)(ORDER_ENTRY_FORM_ID, 'side', formValues.side));
        dispatch((0, _reduxForm.change)(ORDER_ENTRY_FORM_ID, 'orderType', formValues.orderType));
        dispatch((0, _reduxForm.change)(ORDER_ENTRY_FORM_ID, 'anchoredField', formValues.anchoredField));
        dispatch((0, _marginActions.refreshMarginAccountInfo)());
        dispatch((0, _actions.refreshMarginAccountEquity)());
      });
    },
    confirmFuturesOrder: function confirmFuturesOrder(formValues) {
      dispatch((0, _orderEntryActions.placeFuturesOrder)(formValues)).then(function () {
        dispatch((0, _reduxForm.reset)(_FuturesOrderEntryFormContainer.FUTURES_ORDER_FORM_NAME));
        dispatch((0, _reduxForm.change)(_FuturesOrderEntryFormContainer.FUTURES_ORDER_FORM_NAME, 'side', formValues.side));
        dispatch((0, _reduxForm.change)(_FuturesOrderEntryFormContainer.FUTURES_ORDER_FORM_NAME, 'orderType', formValues.orderType));
        dispatch((0, _reduxForm.change)(_FuturesOrderEntryFormContainer.FUTURES_ORDER_FORM_NAME, 'orderByProduct', formValues.orderByProduct));
      });
    }
  };
};
var _default = exports["default"] = (0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.CONFIRM_ORDER_REPORT
})((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ConfirmOrderModalComponent["default"]));